import styled, { css } from 'styled-components'

const Text = styled.p`
  img {
    margin-left: 3px;
    display: inline-block;
  }
  margin: 0;
  text-align: ${(props) => props.align};
  ${(props) =>
    props.align === 'center' ? 'margin: 0 auto;' : ''} word-wrap: break-word;
  text-transform: ${(props) =>
    props.allCaps ? 'uppercase' : props.capitalize ? 'capitalize' : null};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : '')};
  ${(props) =>
    props.fluid
      ? css`
          width: 100%;
        `
      : ''};
  font-weight: ${(props) =>
    props.bold ? '600' : props.semiBold ? '600' : '400'};
  ${(props) =>
    props.color
      ? css`
          color: ${(props) => props.theme[props.color]};
        `
      : ''};
  ${(props) =>
    props.inverse
      ? css`
          color: white;
        `
      : ''};
  ${(props) =>
    props.underline
      ? css`
          text-decoration: underline;
        `
      : ''};
  ${(props) =>
    props.italic
      ? css`
          font-style: italic;
        `
      : ''};

  ${(props) =>
    props.small
      ? css`
          font-size: 18px;
          line-height: 25px;
        `
      : ''};
  ${(props) =>
    props.large
      ? css`
          font-size: 21px;
          line-height: 40px;
        `
      : ''};
`

export default Text
